<template>
  <div style="background-color: #edf4fc;height: 100vh;">
    <div style="height: 0.5rem;width: 100%;">
      <div style="margin-right: 0.1rem;float: right;width: 100%;">
        <a href="javascript:void(0)" @click="manager('/')" style="float: left;">
          <img src="@/assets/logo.gif" alt="联考之家" class="menu-img-size" />
        </a>
        <div class="header-home">
          <a href="javascript:void(0)" @click="manager('/contact')" class="header-home-a">联系我们</a>
        </div>
        <div class="header-home">
          <a href="javascript:void(0)" @click="manager('/')" class="header-home-a">首页</a>
        </div>
      </div>
    </div>
    <div class="login-form">
      <div class="login-form-div1">登录</div>
      <div class="login-form-div2">请使用账号进行登录</div>
      <el-form ref="form" :model="form" label-width="0" :rules="rules">
        <el-form-item prop="userName">
          <el-input v-model="form.userName" placeholder="账号" autofocus="true"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" placeholder="密码" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loginName" class="login-form-button">登录</el-button>
        </el-form-item>
      </el-form>
      <div class="login-form-div3">
        <a href="javascript:void(0)" @click="manager('/findpassword')" class="login-password">找回密码</a>
        <a href="javascript:void(0)" @click="manager('/register')" class="login-register">注册</a>
      </div>
    </div>

  </div>
</template>

<script>
import { loginNameAPI } from '@/api/user'
// 1. 按需导入辅助方法
import { mapActions, mapMutations } from 'vuex'

export default {
  // name 是当前组件的名称（建议为每个组件都指定唯一的 name 名称）
  name: 'Login',
  data () {
    return {
      // 登录表单的数据，最终要双向绑定到 form 这个数据对象上
      form: {
        // 用户的手机号
        userName: '',
        // 登录的密码
        password: ''
      },
      // 表单的校验规则对象
      rules: {
        userName: [
          { required: true, message: '请填写您的用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写您的密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 2. 映射 mutations 中的方法
    ...mapMutations(['updateTokenCustomer']),
    // 从 vuex 中把指定名称的 Action 方法映射到组件中使用
    ...mapActions(['initUserCustomer']),

    async loginName () {
      if (this.form.userName !== '' && this.form.password !== '') {
        // 只有当表单数据校验通过之后，才会调用此 login 函数
        const { data: res } = await loginNameAPI(this.form)
        // 判断是否登录成功了
        if (res.code === 200) {
          // 把登录成功的结果，存储到 vuex 中
          this.updateTokenCustomer(res.data)
          // 跳转到访问未遂的路由地址
          if (this.$route.path === '/login') {
            setTimeout(() => {
              this.$router.push('/')
            }, 100)
          } else {
            const navPath = this.$route.query.pre || '/'
            this.$router.push(navPath)
          }
          this.initUserCustomer()
        } else if (res.code === 405) {
          this.$message({
            message: res.message,
            type: 'warning'
          })
        } else if (res.code === 406) {
          this.$message({
            message: res.message,
            type: 'warning'
          })
        } else {
          this.$message({
            message: '账号或密码错误',
            type: 'warning'
          })
        }
      } else {
        this.$message({
          message: '账号或密码为空',
          type: 'warning'
        })
      }
    },
    managerBlank (address) {
      const routeData = this.$router.resolve({ path: address })
      window.open(routeData.href, '_blank')
    },
    manager (address) {
      this.$router.push({ path: address })
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
.menu-img-size {
  width: 1rem;
  height: 0.5rem;
}
.header-home {
  float: right;
  margin-right: 0.1rem !important;
  width: 0.9rem;
  height: 0.5rem;
  font-size: 0.13rem;
}
.header-home-a {
  display: inline-block;
  width: 0.9rem;
  height: 0.5rem;
  line-height: 0.5rem;
  vertical-align: middle;
  text-align: center;
}
.login-form {
  right: 1rem;
  width: 3.5rem;
  margin: 0 auto;
  margin-top: 1rem;
  margin-left: 5.5rem;
}
.login-form-div1 {
  display: inline-block;
  height: 0.4rem;
  width: 3.5rem;
  vertical-align: middle;
  text-align: center;
  font-size: 0.3rem;
  margin-bottom: 0.1rem;
}
.login-form-div2 {
  display: inline-block;
  height: 0.2rem;
  width: 3.5rem;
  vertical-align: middle;
  text-align: center;
  font-size: 0.13rem;
  color:gray;
  margin-bottom: 0.2rem;
}
.login-form-button {
  width: 3.5rem;
  margin: 0 auto;
  font-size: 0.13rem;
}
.login-form-div3 {
  height: 0.5rem;
  width: 3.5rem;
  font-size: 0.13rem;
}
.login-password {
  float: left;
}
.login-password:hover {
  color: blue;
}
.login-register {
  float: right;

}
.login-register:hover {
  color: blue;
}
/deep/ .el-form-item {
  margin-bottom: 0.2rem;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
/deep/ .el-form-item__label {
  font-size: 0.13rem;
}
</style>
